"use client";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { v4 as uuidv4 } from "uuid";
import { getCookie, setCookie } from "cookies-next";

const DEVICE_COOKIE = "deviceIdDot";

/**
 * Get device id from cookie or generate it
 */
export const getDeviceId = async (): Promise<string> => {
  try {
    // 1️⃣ Check cookie first
    const existingId = getCookie(DEVICE_COOKIE) as string;

    if (existingId) {
      return existingId;
    }

    // 2️⃣ Generate fingerprint
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    let deviceId = result?.visitorId;

    // 3️⃣ If fingerprint fails use UUID fallback
    if (!deviceId) {
      deviceId = uuidv4();
    }

    // 4️⃣ Store cookie for 55 years
    setCookie(DEVICE_COOKIE, deviceId, {
      path: "/",
      maxAge: 60 * 60 * 24 * 365 * 55,
      sameSite: "lax",
    });

    return deviceId;
  } catch (error) {
    console.error("Device fingerprint failed:", error);

    // 5️⃣ Emergency fallback random ID
    const fallbackId = uuidv4();

    setCookie(DEVICE_COOKIE, fallbackId, {
      path: "/",
      maxAge: 60 * 60 * 24 * 365 * 55,
    });

    return fallbackId;
  }
};